import { useClientInfoStore } from '@btcdirect/stores';

interface DateParts {
    hour: number;
    weekday: string;
}

/**
 * Check if we're currently inside office hours
 */
export function isInOfficeHours(): boolean {
    const clientInfoStore = useClientInfoStore();

    // If the client uses estimated quotes, we're opened 24/7 for bankTransfer orders
    if (clientInfoStore.client.usesEstimatedQuotes) {
        return true;
    }

    const today = getCurrentDayAndHourInBtcDirectTimezone();
    const opened = ['saturday', 'sunday'].includes(today.weekday) ? { from: 10, to: 17 } : { from: 9, to: 21 };

    return today.hour >= opened.from && today.hour < opened.to;
}

/**
 * Get the user's current weekday and hour, translated to the value in the Netherlands
 * Example; if it's 13:00 in London, it will return 15 (or 14 during daylight savings)
 */
function getCurrentDayAndHourInBtcDirectTimezone(): DateParts {
    const formatter = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'long', hour: '2-digit' });
    const parts = formatter.formatToParts(new Date());

    return {
        hour: Number(parts.find((item) => item.type === 'hour').value),
        weekday: parts.find((item) => item.type === 'weekday').value.toLowerCase()
    };
}
